import React from "react";

import MaterialTable from "material-table";

import service from '../../../plas/user/service.jsx';

function TablePlaces({ 
  open
}) {

  const tableRef = React.useRef();
  
  return (
    <div>
      <MaterialTable
        tableRef={tableRef}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsPerPage: "Filas por página",
            labelRowsSelect: "Filas",
            firstAriaLabel: "Primera página",
            firstTooltip: "Primera página",
            previousAriaLabel: "Página anterior",
            previousTooltip: "Página anterior",
            nextAriaLabel: "Próxima página",
            nextTooltip: "Próxima página",
            lastAriaLabel: "Última página",
            lastTooltip: "Última página",
          },
          toolbar: {
            nRowsSelected: "{0} filas(s) seleccionadas",
            searchTooltip: "Buscar",
            searchPlaceholder: "Buscar",
          },
          header: {
            actions: "Acciones",
          },
          body: {
            emptyDataSourceMessage: "No hay usuarios para mostrar",
            deleteTooltip: "Eliminar",
            editTooltip: "Editar",
            filterRow: {
              filterTooltip: "Filtrar",
            },
            editRow: {
              saveTooltip: "Confirmar",
              cancelTooltip: "Cancelar",
            },
          },
        }}
        title={"Usuarios"}
        columns={[
          { title: "ID", field: "id",  editable: "never", cellStyle: {width:"5%"}, headerStyle:{width:"5%"},
            render: rowData => <span>{rowData.id}</span> },
          { title: "Correo electrónico", field: "placeCategory.name", editable: "never", sorting: false, cellStyle: {width:"25%"}, headerStyle:{width:"25%"},
            render: rowData => <span>{ rowData.email }</span> },
          { title: "Nombre", field: "name", sorting: false, cellStyle: {width:"25%"}, headerStyle:{width:"25%"},
            render: rowData => <span>{rowData.userProfile ? rowData.userProfile.name : "-"}</span>},
          { title: "Apellido", field: "lastName", editable: "never", sorting: false, cellStyle: {width:"25%"}, headerStyle:{width:"25%"},
            render: rowData => <span>{rowData.userProfile ? rowData.userProfile.lastName : "-"}</span>},
          { title: "Teléfono", field: "phoneNumber", editable: "never", sorting: false, cellStyle: {width:"15%"}, headerStyle:{width:"15%"},
            render: rowData => <span>{rowData.userProfile ? rowData.userProfile.phoneNumber : "-"}</span>}
        ]}
        actions={[
          rowData => ({
            icon: "edit",
            tooltip: "Editar",
            onClick: (event, rowData) => open(event, rowData)
          })
        ]}
        options={{
          sorting: false,
          draggable: false,
          addRowPosition: "first",
          actionsColumnIndex: -1,
          tableLayout: 'auto',
          actionsCellStyle: { },
          rowStyle: {
            fontSize: 15,
          }
        }}
        data={ query =>
          new Promise((resolve, reject) => {
            let from = query.page * query.pageSize;
            let to = from + query.pageSize;
            let keyword = query.search;

            service.api.users.getPage(from, to, keyword, "+id", (response) => {

              if (response.result != null) {
                resolve({
                  data: response.result.data,
                  page: query.page,
                  totalCount: response.result.total,
                });
              } else {
                reject();
              }
            }); 
          })
        }
      />
    </div>
  );

}


export default TablePlaces;